const $ = require('jquery');

'use strict';

const PLUGIN_NAME = 'protectedContent';

const	DEFAULTS = {
  htmlClass: 'login-alert',
  content: 'Pro zobrazení se prosím přihlaste.',
  buttonTitle: 'Přihlásit se',
  buttonHtmlClass: 'btn btn-default btn-key',
  buttonHref: '/cs/prihlaseni',

  childContent: 'Pro přidání hodnocení musíte mít vyplněný kompletní profil. Chybí vám informace o dětech.',
  childButtonHref: '/qf/cs/ramjet/registration/profileDialog?frm.fbComplete=1#fsChildren',
  childButtonTitle: 'Editovat profil'
};

const ProtectedContent = function (selector, options) {
  this.$t = $(selector);
  this.options = $.extend(true, {}, DEFAULTS, options);
  this._defaults = DEFAULTS;
  this.initialise_();
};

ProtectedContent.prototype.initialise_ = function () {
  this.childrenWarning = this.$t.hasClass('display-children-warning');
  this.renderContent_();
};

ProtectedContent.prototype.renderContent_ = function () {
  if (this.childrenWarning) {
    this.$t.after(this.buildChildrenWarningContent_());
  } else {
    // this.$t.after(this.buildContent_());
  }
};

ProtectedContent.prototype.buildContent_ = function () {
  let str = '';
  str += `<div class="${this.options.htmlClass}">`;
  str += `<p>${this.options.content}</p>`;
  str += `<p><a href="${this.options.buttonHref}" class="${this.options.buttonHtmlClass}">${this.options.buttonTitle}</a>`;
  str += '</div>';
  return str;
};

ProtectedContent.prototype.buildChildrenWarningContent_ = function () {
  let str = '';
  str += `<div class="${this.options.htmlClass}">`;
  str += `<p>${this.options.childContent}</p>`;
  str += `<p><a href="${this.options.childButtonHref}" class="${this.options.buttonHtmlClass}">${this.options.childButtonTitle}</a>`;
  str += '</div>';
  return str;
};

/**
 * decide, which methods will be "public"
 */
const API = {};

/**
 * plugin go live
 * @param value - first param - decides, which action shall be executed
 * 		if object - apply plugin with these settings to an selector's elements, if they are clean (plugin not applied yet)
 * 		if string && in API object - run method named as this value with all args[index > 0]
 * @return {*}
 */
$.fn[PLUGIN_NAME] = function (value) {
  const args = arguments;

  return this.each(function () {
    const $this = $(this);

    // get plugin instance
    let plugin = $this.data(`plugin_${PLUGIN_NAME}`);

    // if there's not, create one
    if (!plugin) {
      plugin = new ProtectedContent(this, value);
      $this.data(`plugin_${PLUGIN_NAME}`, plugin);
    }
    // if there is and first parameter is in predefined API methods, call it with rest of params
    else if (API[value]) {
      plugin[value](...Array.prototype.slice.call(args, 1));
    }
  });
};



// WEBPACK FOOTER //
// ./fe/web-default/src/js/web/jquery.protected-content.js